import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { supabase } from '@appic/lib/supabase'

/** Invalidate inbox + agent-signals queries when `agent_signals` rows change (Supabase Realtime). */
export function useAgentSignalsRealtime() {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (typeof supabase.channel !== 'function') return

    const channel = supabase
      .channel('agent_signals')
      .on(
        'postgres_changes' as any,
        { event: '*', schema: 'public', table: 'agent_signals' },
        () => {
          void queryClient.invalidateQueries({ queryKey: ['agent-signals'] })
          void queryClient.invalidateQueries({ queryKey: ['inbox'] })
        },
      )
      .subscribe()

    return () => {
      void supabase.removeChannel(channel)
    }
  }, [queryClient])
}
